module.exports = __webpack_public_path__ + "static/img/sjys.1b0c48b4.png";